import {Button, CardHeader, MenuItem, Paper, Select, Switch, Table, TableBody, TableCell, TableRow, TextField} from "@mui/material";
import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";

export class Maintenance extends React.Component<any, any> {
    constructor(props) {
        super(props);

        // Flag for general, google, apple, huawei, samsung
        this.state = {
            maintenanceFlag: false,
            maintenanceFlagGoogle: false,
            maintenanceFlagApple: false,
            maintenanceFlagSamsung: false,
            maintenanceTime: "",
            maintenanceText: "",
            whiteList: "",
            reason: 0
        };

        document.title = Helpers.documentTitle("Maintenance");
    }

    componentDidMount() {
        this.getMaintenanceState();
    }

    refreshData = () => {
        this.getMaintenanceState();
    }

    getMaintenanceState = async () => {
        try {
            const url = `${Config.getInstance.apiUrl}/api/maintenance/`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            });

            const data = response.data;

            this.setState(data);
        } catch (error) {
            PopupMessage.error("Couldn't getMaintenanceState");
        }
    }

    changeMaintenanceFlag = async (key, event) => {
        const maintenanceFlag = event.target.checked;

        // If the general flag is false, then all the other flags should be false
        if (key === "maintenanceFlag" && !maintenanceFlag) {
            this.setState({
                maintenanceFlag: maintenanceFlag,
                maintenanceFlagGoogle: false,
                maintenanceFlagApple: false,
                maintenanceFlagHuawei: false,
                maintenanceFlagSamsung: false,
            });
        } else {
            this.setState({[key]: maintenanceFlag});
        }
    }

    changeStateValue = (key, event) => {
        const value = event.target.value;
          // Check if the key is nested (e.g., "server.whiteList")
        if (key.includes('.')) {
            const keys = key.split('.');
            this.setState(prevState => ({
                [keys[0]]: {
                    ...prevState[keys[0]],
                    [keys[1]]: value
                }
            }));
        } else {
            this.setState({ [key]: value });
        }
    }

    renderDropdown = () => {
        return <Select labelId="type-permissions" autoWidth={true} size="small"
            name={"True"}
            value={this.state.maintenanceFlag}
            onChange={this.changeMaintenanceFlag}
        >
            <MenuItem value="true">True</MenuItem>
            <MenuItem value="false">False</MenuItem>
        </Select>
    };

    async submit() {
        const url = `${Config.getInstance.apiUrl}/api/maintenance/`;

        // Trim all white space
        const whiteList = this.state.whiteList.replace(/\s/g, '');

        const data = {
            maintenanceFlag: this.state.maintenanceFlag,
            maintenanceFlagGoogle: this.state.maintenanceFlagGoogle,
            maintenanceFlagApple: this.state.maintenanceFlagApple,
            maintenanceFlagHuawei: this.state.maintenanceFlagHuawei,
            maintenanceFlagSamsung: this.state.maintenanceFlagSamsung,
            maintenanceTime: this.state.maintenanceTime,
            maintenanceText: this.state.maintenanceText,
            whiteList,
            reason: +this.state.reason
        };

        try {
            await axios.post(url, data, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            });

            PopupMessage.success("Maintenance saved");

            this.getMaintenanceState();
        } catch (error) {
            PopupMessage.error("Couldn't save maintenance");
        }
    }

    render() {
        const state = this.state;
        return <div className="contentPadding" style={{width: "100%"}}>
            <Paper className="root" elevation={0}>
                <CardHeader title="Maintenance Info" />
                <React.Fragment>
                    <Table className="min-table-size">
                        <TableBody>
                            <TableRow>
                                <TableCell width={"20%"}>Maintenance</TableCell>
                                <TableCell>
                                    <Switch
                                        checked={this.state.maintenanceFlag}
                                        onChange={this.changeMaintenanceFlag.bind(this, "maintenanceFlag")}
                                        name="maintenanceFlag"
                                        inputProps={{'aria-label': 'controlled'}}
                                    />
                                </TableCell>
                            </TableRow>
                            {/* {
                                !this.state.maintenanceFlag ?
                                    <TableRow>
                                        <TableCell width={"20%"}>Maintenance Google</TableCell>
                                        <TableCell>
                                            <Switch
                                                disabled={this.state.maintenanceFlag}
                                                checked={this.state.maintenanceFlagGoogle}
                                                onChange={this.changeMaintenanceFlag.bind(this, "maintenanceFlagGoogle")}
                                                name="maintenanceFlag"
                                                inputProps={{'aria-label': 'controlled'}}
                                            />
                                        </TableCell>
                                    </TableRow>
                                    : null
                            }

                            {
                                !this.state.maintenanceFlag ?
                                    <TableRow>
                                        <TableCell width={"20%"}>Maintenance Apple</TableCell>
                                        <TableCell>
                                            <Switch
                                                checked={this.state.maintenanceFlagApple}
                                                onChange={this.changeMaintenanceFlag.bind(this, "maintenanceFlagApple")}
                                                name="maintenanceFlag"
                                                inputProps={{'aria-label': 'controlled'}}
                                            />
                                        </TableCell>
                                    </TableRow>
                                    : null
                            } */}

                            {/* <TableRow>
                                <TableCell width={"20%"}>Maintenance Flag Huawei</TableCell>
                                <TableCell>
                                    <Switch
                                        checked={this.state.maintenanceFlagHuawei}
                                        onChange={this.changeMaintenanceFlag.bind(this, "maintenanceFlagHuawei")}
                                        name="maintenanceFlag"
                                        inputProps={{'aria-label': 'controlled'}}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell width={"20%"}>Maintenance Flag Samsung</TableCell>
                                <TableCell>
                                    <Switch
                                        checked={this.state.maintenanceFlagSamsung}
                                        onChange={this.changeMaintenanceFlag.bind(this, "maintenanceFlagSamsung")}
                                        name="maintenanceFlag"
                                        inputProps={{'aria-label': 'controlled'}}
                                    />
                                </TableCell>
                            </TableRow> */}

                            <TableRow>
                                <TableCell>Maintenance Time</TableCell>
                                <TableCell>
                                    <TextField
                                        style={{backgroundColor: "#505050"}}
                                        fullWidth
                                        id="fullWidth"
                                        value={this.state.maintenanceTime}
                                        onChange={this.changeStateValue.bind(this, "maintenanceTime")}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Maintenance Text</TableCell>
                                <TableCell>
                                    <TextField
                                        style={{backgroundColor: "#505050"}}
                                        fullWidth
                                        id="fullWidth"
                                        value={this.state.maintenanceText}
                                        onChange={this.changeStateValue.bind(this, "maintenanceText")}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>whiteList (Seperate by , Ex: 192.168.0.11,192.168.0.12)</TableCell>
                                <TableCell>
                                    <TextField
                                        style={{backgroundColor: "#505050"}}
                                        fullWidth
                                        id="fullWidth"
                                        value={this.state.whiteList}
                                        onChange={this.changeStateValue.bind(this, "whiteList")}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>whiteList Devices ID <br></br>  (Seperate by , Ex: 192.168.0.11,192.168.0.12)</TableCell>
                                <TableCell>
                                    <TextField
                                        style={{backgroundColor: "#505050"}}
                                        fullWidth
                                        id="fullWidth"
                                        value={this.state.server?.whiteList}
                                        onChange={this.changeStateValue.bind(this, "server.whiteList")}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>Reason (Number, For Example: 0, 1, 2, 3, 4)</TableCell>
                                <TableCell>
                                    <TextField
                                        style={{backgroundColor: "#505050"}}
                                        fullWidth
                                        id="fullWidth"
                                        value={this.state.reason}
                                        onChange={this.changeStateValue.bind(this, "reason")}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>
                                <Button style={{float: "right"}} variant="contained" color="secondary" onClick={this.submit.bind(this)}>Submit</Button>
                                </TableCell>
                            </TableRow>

                        </TableBody>
                    </Table>
                </React.Fragment>
            </Paper>
        </div>;
    }
}
